export class Filters {
  Column_OrigName: string;
  NumOrRatingOrStr: number;
  Column_Index: number
  Result_Type: string;
  Column_Name: string;
  Operator: string;
  OperatorNum: number;
  Value: string;
  Value_To: string;
  AndOr: string;

  constructor() {
    this.Column_OrigName = "";
    this.NumOrRatingOrStr = 0;
    this.Column_Index = 0;
    this.Result_Type = "";
    this.Column_Name = "";
    this.Operator = "";
    this.OperatorNum = 0;
    this.Value = "";
    this.Value_To = "";
    this.AndOr = "";
  }

}
